import { styled } from 'styled-components';

import { theme } from '@/shared/theme';
import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    display: flex;
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    justify-content: space-between;
    margin-bottom: 16px;

    ${mq.lt.md} {
        flex-direction: column;
        padding: 12px;
    }

    &:last-child {
        margin-bottom: 0;
    }

    .img-block {
        max-width: 220px;
        ${mq.lt.md} {
            display: flex;
            justify-content: space-between;
            max-width: 100%;
        }

        .img {
            width: 220px;
            height: 145px;
            position: relative;

            & img {
                width: initial !important;
                min-width: initial !important;
            }

            ${mq.lt.lg} {
                width: 135px;
                height: 115px;
            }

            ${mq.lt.md} {
                width: 220px;
                height: 145px;
                margin-bottom: 16px;
            }
        }

        .action-bar {
            display: flex;
            height: 30px;
            align-items: center;

            > div {
                &:first-child {
                    margin-right: 24px;
                }
            }
        }
    }

    .card-block {
        flex: 1;
        padding: 0 20px;
        ${mq.lt.md} {
            padding: 0;
        }

        .card-block__calculator {
            width: 50%;
            display: flex;
            flex-direction: column;
            gap: 8px;

            .calculator-title {
                font-weight: 500;
                font-size: ${({ theme }) => theme.fontSize.sm};
            }
        }

        .title {
            margin-bottom: 16px;

            a {
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                line-height: 120%;
                color: ${theme.color.dark};
                word-break: break-word;
            }
        }

        .city {
            margin-bottom: 32px;

            > div {
                &:first-child {
                    margin-bottom: 8px;
                }

                &:last-child {
                    font-style: normal;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 130%;
                    color: ${theme.color.primary};
                }

                .inf-delivery {
                    display: flex;
                    gap: 5px;
                    align-items: center;
                }
            }
        }
    }

    .action-block {
        max-width: 320px;
        flex: 1;
        min-width: 282px;

        ${mq.lt.lg} {
            max-width: 250px;
            min-width: 220px;
        }
        ${mq.lt.md} {
            margin-top: 0;
            max-width: 100%;
        }

        .action-bar {
            display: flex;
            align-items: center;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 130%;
            color: #00d9de;
            justify-content: end;

            > div {
                &:first-child {
                    margin-right: 20px;
                }

                &:last-child {
                    margin-right: 0;
                }
            }

            .btn {
                display: flex;
                align-items: center;
                cursor: pointer;

                &.delete {
                    color: ${({ theme }) => theme.color.neutral300};
                }

                svg {
                    margin-right: 9px;
                }
            }
        }

        .info {
            margin-top: 32px;

            > div {
                &:first-child {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 120%;
                    color: #1f2547;
                    margin-bottom: 6px;
                }

                &:last-child {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 120%;
                    color: #1f2547;
                    margin-bottom: 24px;
                }
            }
        }
    }
`;

export const Content = styled.div`
    width: 320px;
`;
